/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-operations-chevron-mini': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M19.375 11.875v7.5h-7.5z"/>'
  }
})
